import ForPage from './ForPage';
import ForPost from './ForPost';
import { BlogCtaCardFragmentFragment } from '../../__generated__/graphql';
import { ContentBlock } from '../types';

interface BlogCtaCardProps {
  pageType: 'page' | 'post';
}

const BlogCtaCard: ContentBlock<BlogCtaCardFragmentFragment, BlogCtaCardProps> = ({ fragment, pageType }) => {
  const contentBlockProps = fragment.blogCtaCard;

  if (!contentBlockProps) {
    return null;
  }

  if (pageType === 'post') {
    return <ForPost fragment={fragment} />;
  }

  return <ForPage fragment={fragment} />;
};

export default BlogCtaCard;
